import { QueryKey } from '@tanstack/react-query';
import { API_ENDPOINTS } from '../httpConstants';
import {
  PermissionCategoryGroupDto,
  RoleDetailDto,
  RoleListItemDto,
  UpdateRolePermissionsDto,
} from '../types/role.types';
import {
  useDetailQuery,
  useListQuery,
  usePutActionMutation,
} from './useCrud';

const ROLES_QUERY_KEY = API_ENDPOINTS.TENANT.ROLES.BASE;

export const useRolesListQuery = () =>
  useListQuery<RoleListItemDto>(API_ENDPOINTS.TENANT.ROLES.BASE);

export const usePermissionsCatalogQuery = () =>
  useListQuery<PermissionCategoryGroupDto>(API_ENDPOINTS.TENANT.ROLES.PERMISSIONS_CATALOG);

export const useRoleDetailQuery = (roleId: string) =>
  useDetailQuery<RoleDetailDto>(API_ENDPOINTS.TENANT.ROLES.WITH_ID, { id: roleId });

export const useUpdateRolePermissionsMutation = () =>
  usePutActionMutation<RoleDetailDto, UpdateRolePermissionsDto>(
    API_ENDPOINTS.TENANT.ROLES.UPDATE_PERMISSIONS,
    [[ROLES_QUERY_KEY] as QueryKey],
  );
